import React from 'react';
import { Clock3, Database, Mic, PhoneIncoming, PhoneOutgoing } from 'lucide-react';
import { formatDuration } from '../../calls/callModel';
import { formatBytes } from '../recordingsModel';

/** The five figures across the top: every recording the company keeps (not just this page). */
export default function RecordingStats({ stats, onFilter }) {
  const s = stats;
  const rows = [
    ['Total Recordings', s?.total, 'Kept now', Mic, 'purple', {}],
    ['Incoming Calls', s?.inbound, 'Recorded', PhoneIncoming, 'green', { direction: 'inbound' }],
    ['Outgoing Calls', s?.outbound, 'Recorded', PhoneOutgoing, 'blue', { direction: 'outbound' }],
    ['Average Duration', s ? formatDuration(s.average_seconds) : null, 'Per recording', Clock3, 'violet', null],
    ['Storage Used', s ? formatBytes(s.storage_bytes) : null, s?.size_unknown ? `${s.size_unknown} not measured yet` : 'Audio stored', Database, 'gold', null],
  ];
  return (
    <div className="cl-stats rc-stats">
      {rows.map(([label, value, note, Icon, tone, filter]) => {
        const Tag = filter ? 'button' : 'div';
        return (
          <Tag key={label} className="cl-stat" {...(filter && { type: 'button', onClick: () => onFilter(filter), title: `Show ${label.toLowerCase()}` })}>
            <span className={`cl-stat-icon ${tone}`}><Icon size={19} /></span>
            <span><small>{label}</small><b>{value ?? '…'}</b><em>{note}</em></span>
          </Tag>
        );
      })}
    </div>
  );
}
